export default "__VITE_ASSET__BWhYCa2A__"